import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["src", "alt", "size", "dimmed", "outlineWidth", "id"];
import "core-js/modules/es.array.concat.js";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import useUniqueId from 'hooks/useUniqueId';
import { pxToRem } from 'utils/ui';
var Svg = styled.svg.withConfig({
  displayName: "StickerImage__Svg",
  componentId: "sc-w95sum-0"
})(["width:", ";height:auto;overflow:visible;"], function (p) {
  return pxToRem(p.width);
});
var StickerImage = /*#__PURE__*/forwardRef(function (props, ref) {
  var src = props.src,
    alt = props.alt,
    _props$size = props.size,
    size = _props$size === void 0 ? 60 : _props$size,
    _props$dimmed = props.dimmed,
    dimmed = _props$dimmed === void 0 ? false : _props$dimmed,
    outlineWidthProp = props.outlineWidth,
    id = props.id,
    otherProps = _objectWithoutProperties(props, _excluded);
  var outlineWidth = outlineWidthProp || size / 30;
  var safetyMargin = outlineWidth * 1.3;
  var imageSize = size - safetyMargin * 2;
  var dropShadowStrength = 0.25;
  var uniqueId = useUniqueId(id);
  var filterId = "".concat(uniqueId, "-filter");
  return /*#__PURE__*/React.createElement(Svg, _extends({}, otherProps, {
    ref: ref,
    id: uniqueId,
    width: size,
    height: size,
    viewBox: "0 0 ".concat(size, " ").concat(size),
    role: "img",
    "aria-label": alt
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: filterId
  }, /*#__PURE__*/React.createElement("feMorphology", {
    operator: "dilate",
    radius: outlineWidth,
    in: "SourceAlpha",
    result: "THICKEN"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#FFFFFF",
    result: "COLOR_WASH"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "COLOR_WASH",
    in2: "THICKEN",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#FFFFFF",
    floodOpacity: "0.3333",
    result: "DIM_WASH"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "DIM_WASH",
    in2: "SourceAlpha",
    operator: "in",
    result: "DIM_SHAPE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }), dimmed && /*#__PURE__*/React.createElement("feMergeNode", {
    in: "DIM_SHAPE"
  })), dimmed && /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "saturate",
    values: "0"
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: "0",
    dy: "1",
    stdDeviation: "1.2",
    floodOpacity: dropShadowStrength,
    floodColor: "black"
  }))), /*#__PURE__*/React.createElement("image", {
    xlinkHref: src,
    x: safetyMargin,
    y: safetyMargin,
    width: imageSize,
    height: imageSize,
    filter: "url(#".concat(filterId, ")")
  }));
});
StickerImage.displayName = 'StickerImage';
export default StickerImage;